import { Drawer } from '@mui/material';
import React from 'react';
import { Outlet, useNavigate, useOutletContext } from 'react-router-dom';

import { ContactsDrawerContext } from '@/types/contactDrawerContext';

export const DrawerContainer: React.FC = (): React.ReactElement => {
  const { contactId, accountId } = useOutletContext<ContactsDrawerContext>();
  const [open, setOpen] = React.useState<boolean>(false);

  const navigate = useNavigate();

  const onClose = React.useCallback((): void => {
    navigate('/contacts', { replace: true });
  }, [navigate]);

  React.useEffect((): void => {
    // WARNING: without this, the animation does not happen because the
    //          first time this component is rendered and due to how the
    //          routes are set up, "open" is true from the start.
    //
    //          This "creates the illusion" of setting it later.
    setTimeout((): void => {
      setOpen(!!contactId || !!accountId);
    }, 0);
  }, [contactId, accountId]);

  return (
    <Drawer open={open} anchor="right" onClose={onClose}>
      <Outlet />
    </Drawer>
  );
};
